import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

const useSchema = () => {
  const { t } = useTranslation();

  return useMemo(
    () =>
      yup.object().shape({
        comment: yup.string().required(t('common.form.validation.required')),
      }),
    [t],
  );
};

export default useSchema;
